import type {AppDispatch} from '~/redux/store'

/**
 * The store registers itself here at startup (see `~/index.tsx`) rather than the API client
 * importing `~/redux/store`, which would put the whole reducer tree on the import path of every
 * consumer of `~/api/endpoints`. Dependencies point redux → api, never the reverse.
 */
let dispatch: AppDispatch | undefined = undefined

export const registerApiDispatch = (d: AppDispatch): void => {
  dispatch = d
}

/**
 * Actions dispatched before anything registers are dropped — the norm in tests, which never
 * register. In the app, registration is synchronous with store creation and nothing requests at
 * module scope, so the warning should never fire.
 */
export const apiDispatch = (action: Parameters<AppDispatch>[0]): void => {
  if (dispatch) {
    dispatch(action)
  } else {
    console.warn('apiDispatch: no store registered yet; dropping action', action)
  }
}
